import { Base } from 'src/api/Base'

export class ProductAPI extends Base {
  static get entity() {
    return 'product'
  }

  static async create({ name, description, strategy, productCategoryId }) {
    const params = {
      ...this.datepicker,
      productCategoryId,
    }

    const body = {
      name,
      description,
      strategy,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/create`, body, { params })

    return data
  }

  static async update({ name, color, id, productId }) {
    const params = {
      ...this.datepicker,
      productId,
    }

    const body = {
      name,
      color,
      id,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/update`, body, { params })

    return data
  }

  static async move({ ordinal, productCategoryId, productId }) {
    const params = {
      ...this.datepicker,
      productId,
    }

    const body = {
      ordinal: ordinal + 1,
      productCategoryId,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/move`, body, { params })

    return data
  }
}
